import React from 'react';
import { useLocation } from '@reach/router';

import { getResponsiveImageAttributes } from '~/common';
import { IconPlay } from '~/src/components/icons';
import { PlayButtonModal } from '~/src/components/LeanBack/common-components';

import { Backdrop, Container, HeroImage, PlayButtonContaner, PlayButtonWrapper } from './elements';
import { useEpisode } from '../EpisodeProvider';

export const Hero: React.FC = () => {
  const episode = useEpisode();
  const bannerImageAttributes = getResponsiveImageAttributes(episode.heroImgSrc());
  const { pathname } = useLocation();
  return (
    <Container>
      <HeroImage {...bannerImageAttributes} />
      <PlayButtonContaner>
        <PlayButtonModal episode={episode} episodeUrl={pathname}>
          <PlayButtonWrapper>
            <Backdrop />
            <IconPlay style={{ height: 70, width: 70 }} />
          </PlayButtonWrapper>
        </PlayButtonModal>
      </PlayButtonContaner>
    </Container>
  );
};
